import { render, staticRenderFns } from "./TaxArrangement.vue?vue&type=template&id=7ae3db82&scoped=true"
import script from "./TaxArrangement.vue?vue&type=script&lang=js"
export * from "./TaxArrangement.vue?vue&type=script&lang=js"
import style0 from "./TaxArrangement.vue?vue&type=style&index=0&id=7ae3db82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae3db82",
  null
  
)

export default component.exports